import basicController from 'servicestack/basic.controller.properties'
import templateUrl from 'emun.markdown/markdown-edit.htm'
import Product from 'emun.shopping/product.model'
import AutoQuery from 'servicestack/auto-query/auto-query'
import resolve from 'ioc/resolve'

class MarkdownEditController {
    constructor() {
        const $ctrl = this;
        basicController($ctrl);
    }
    $onInit(){
        const $ctrl = this;
        const id = $ctrl.markdownId;
        this.selectAll = false;
        this.types = [{ id: 'Permanent' }, { id: 'Temporary' }];
        this.discountTypes = [{ id: 'Dollar' }, { id: 'Percentage' }];
        if (id == 'create') {
            this.markdown = { id: 'create' };
        } else {

            let options = {
                url: 'QueryMarkdowns.json?Id=' + id,
                autoLoad: true,
                append: true,
                onLoaded: args => {
                    this.markdown = args.first
                    this.markdown.startOn = moment(this.markdown.startOn);
                    this.markdown.endOn = moment(this.markdown.endOn);
                    this.markdown.startDateString = moment(this.markdown.startOn).format("MM/DD/YYYY hh:mm a");
                    this.markdown.endDateString = moment(this.markdown.endOn).format("MM/DD/YYYY hh:mm a");
                }
            };
            this.query = new AutoQuery(options);
            this.mproducts = new AutoQuery({
                url: 'QueryMarkdownProducts/' + id, autoLoad: true, pageSize: 24, append: false, scrub(response) {
                    response.data.results = Product.map(response.data.results);
                }
            });
        }
        this.products = new AutoQuery({
            url: 'QueryProducts.json',
            orderBy: '-CreatedOn',
            autoLoad: true,
            append: false,
            take: 24,
            scrub(response) {
                response.data.results = Product.map(response.data.results);
            },
            criteria: {
                status: 'Active',
                context: 'shop'
            },
            sortOptions: {
                'Id': 'Id: Low to High',
                '-Id': 'Id: High to Low',
                'ShortDescription,Id': 'Description: A to Z',
                '-ShortDescription,Id': 'Description: Z to A',
                'Cost,Id': 'Cost: Low to High',
                '-Cost,Id': 'Cost: High to Low',
                'RetailPrice,Id': 'Price: Low to High',
                '-RetailPrice,Id': 'Price: High to Low',
                'CreatedOn,Id': 'Created: Newest',
                '-CreatedOn,Id': 'Created: Oldest',
                'Status,Id': 'Status: A to Z',
                '-Status,Id': 'Status: Z to A',
            }
        });
        this.bus = this.products.bus;
    }

    updateMarkdown() {
        let $ctrl = this;
        var action = "UpdateMarkdown";
        if (this.markdown.id == 'create') {
            action = "CreateMarkdown";
        }
        /*        var tempMarkdown = {};
                angular.extend(tempMarkdown, this.markdown);
                tempMarkdown.startOn = this.markdown.startDateString;
                tempMarkdown.endOn = this.markdown.endDateString;
        */
        return this.bus.send(action, this.markdown)
        .then((response) => {
            if (action == "UpdateMarkdown") {
                this.$state.go('markdowns');
            } else {
                var id = response.data.id;
                let options = {
                    url: 'QueryMarkdowns.json?Id=' + id,
                    autoLoad: true,
                    onLoaded: args => {
                        this.markdown = args.first
                        this.markdown.startOn = moment(this.markdown.startOn);
                        this.markdown.endOn = moment(this.markdown.endOn);
                    }
                };
                this.query = new AutoQuery(options);
                this.mproducts = new AutoQuery({ url: 'QueryMarkdownProducts/' + id, autoLoad: true });
                this.products = new AutoQuery({
                    url: 'QueryProducts.json',
                    orderBy: '-CreatedOn',
                    autoLoad: true,
                    append: false,
                    take: 24,
                    criteria: {
                        status: 'Active'
                    },
                    sortOptions: {
                        'Id': 'Id: Low to High',
                        '-Id': 'Id: High to Low',
                        'ShortDescription,Id': 'Description: A to Z',
                        '-ShortDescription,Id': 'Description: Z to A',
                        'Cost,Id': 'Cost: Low to High',
                        '-Cost,Id': 'Cost: High to Low',
                        'RetailPrice,Id': 'Price: Low to High',
                        '-RetailPrice,Id': 'Price: High to Low',
                        'CreatedOn,Id': 'Created: Newest',
                        '-CreatedOn,Id': 'Created: Oldest',
                        'Status,Id': 'Status: A to Z',
                        '-Status,Id': 'Status: Z to A',
                    }
                });

            }
        });
    }

    checkProduct(id) {
        return this.mproducts.results.map(function (e) { return e.id; }).indexOf(id);
    };

    setSelectAll() {
        if (this.selectAll) {
            this.selectAll = false;
        } else {
            this.selectAll = true;
        }
        this.products.results.forEach(function (p, index) {
            this.products.results[index].isSelected = this.selectAll;
        });
    }

    addProduct(id) {
        let $ctrl = this;
        var productIds = [];
        productIds.push(id);
        if ($ctrl.markdown.id == 'create') {
            $ctrl.updateMarkdown().then(function () {
                return $ctrl.bus.send('AddMarkdownProducts', { id: $ctrl.markdown.id, productIds: productIds })
                .then(function (response) {
                    $ctrl.mproducts.load(true).then(function (response) {
                        $ctrl.products.load(true);
                    });
                });
            });
        } else {
            return $ctrl.bus.send('AddMarkdownProducts', { id: $ctrl.markdown.id, productIds: productIds })
            .then(function (response) {
                $ctrl.mproducts.load(true).then(function (response) {
                    $ctrl.products.load(true);
                });
            });
        }
    }

    addAllProducts() {
        let $ctrl = this;
        if ($ctrl.markdown.id == 'create') {
            $ctrl.updateMarkdown().then(function () {
                return $ctrl.bus.send('AddMarkdownProducts', { id: $ctrl.markdown.id, search: $ctrl.products.criteria.search })
                .then(function (response) {
                    $ctrl.mproducts.load(true).then(function (response) {
                        $ctrl.products.load(true);
                    });
                });
            });
        } else {
            return $ctrl.bus.send('AddMarkdownProducts', { id: $ctrl.markdown.id, search: $ctrl.products.criteria.search })
            .then(function (response) {
                $ctrl.mproducts.load(true).then(function (response) {
                    $ctrl.products.load(true);
                });
            });
        }
    }

    removeAllProducts() {
        let $ctrl = this;
        return $ctrl.bus.send('RemoveMarkdownProducts', { id: $ctrl.markdown.id, search: $ctrl.products.criteria.search })
        .then(function (response) {
            $ctrl.mproducts.load(true).then(function (response) {
                $ctrl.products.load(true);
            });
        });
    }

    removeProduct(id) {
        let $ctrl = this;
        var productIds = [];
        productIds.push(id);
        return $ctrl.bus.send('RemoveMarkdownProducts', { id: $ctrl.markdown.id, productIds: productIds })
        .then(function (response) {
            $ctrl.mproducts.load(true).then(function (response) {
                $ctrl.products.load(true);
            });
        });
    }
}

let MarkdownEdit = {
    controller: MarkdownEditController,
    bindings: {
        markdownId:'@'
    },
    templateUrl($element, $attrs) {
        return $attrs.templateUrl || templateUrl
    }
}

export default MarkdownEdit;
